import React from "react";
import { QueryClientProvider, QueryClient } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";

export const queryClient = new QueryClient({
  defaultOptions: {
    // react-query 전역 설정
    queries: {
      retry: false,
      retryOnMount: true,
      refetchOnReconnect: false,
      refetchOnWindowFocus: false,
      staleTime: 30 * 1000,
      cacheTime: 30 * 1000,
    },
  },
});

type Props = {
  children: React.ReactNode;
};

export const RQProvider = ({ children }: Props) => {
  const [client] = React.useState(() => queryClient);

  return (
    <QueryClientProvider client={client}>
      {children}
      <ReactQueryDevtools
        position="top-right"
        initialIsOpen={process.env.NODE_ENV === "development"}
      />
    </QueryClientProvider>
  );
};
